<app-help-page mainVideo="exports"
               [tutorials]="['exports']"
               [videos]="['exports', 'export-destinations']"></app-help-page>
